// extracted by css-extract-rspack-plugin
export default {"grid":"DebugInfoDialog_grid__EJT9X","name":"DebugInfoDialog_name__ydP8h","value":"DebugInfoDialog_value__lx4Kn","demoModeButton":"DebugInfoDialog_demoModeButton__TcQkD"};